import Elevator from 'elevator.js'

/**
 * Collection of ids to be shared across the component.
 * @enum {Object<string>}
 */
const IDS = {
  sectionId: '[data-section-id]'
}

/**
 * All classes used in the component.
 * @enum {Object<string>}
 */
const CLASSES = {
  nav: 'dr-nav'
}

/**
 * All numbers used in the component.
 * @enum {Object<number>}
 */
const NUMBERS = {
  scrollAdjustPadding: 2
}

/**
 * @module MenuHolder
 */
class MenuHolder {
  /**
   * @param {HTMLElement} element - The HTMLElement this module is constructed upon
   */
  constructor(element) {
    this.element_ = element
    this.buttons_ = this.element_.querySelectorAll(`${IDS.sectionId}`)
    this.nav_ = document.querySelector(`.${CLASSES.nav}`)
    this.init()
  }

  /**
   * Construct module.
   */
  init() {
    this.addEventListeners()
  }

  /**
   * Add all events from the component.
   */
  addEventListeners() {
    if (this.buttons_) {
      this.buttons_.forEach(button => {
        const sectionId = button.getAttribute('data-section-id')
        const navHeight = this.nav_.offsetHeight
        const { scrollAdjustPadding } = NUMBERS
        new Elevator({
          element: button,
          targetElement: document.getElementById(sectionId),
          duration: 1000,
          verticalPadding: navHeight - scrollAdjustPadding
        })
      })
    }
  }
}

// Exports
export default MenuHolder
